import { render } from "./HorsePreviewDate.vue?vue&type=template&id=51fcb254"
import script from "./HorsePreviewDate.vue?vue&type=script&lang=js"
export * from "./HorsePreviewDate.vue?vue&type=script&lang=js"

import "./HorsePreviewDate.vue?vue&type=style&index=0&id=51fcb254&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__